module.exports = __webpack_public_path__ + "img/view-off.20e7e413.svg";